<template>
    <div class="mb-8">
      <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />
        <UiImageFlip :article="blogStore.filterArticlesByTag(blog, 'ImagesToTheLeft')[0]" />
    </div>

    <div class="relative">
      <ContentBlogImageGrid :article="blogStore.filterArticlesByTag(blog, 'Additional Info')[0]" />
    </div>

    <UiHeroBottom :article="blogStore.filterArticlesByTag(blog, 'Herobottom')[0]" />


</template>
  
<script setup>
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

// Definiera props
const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});


</script>
  
<style>



</style>
  